/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Account,
  AccountCreate,
  AccountIdp,
  AccountIdpCreate,
  AccountIdpUpdate,
  AccountOps,
  AccountOpsSet,
  AccountUpdate,
  ApiLog,
  AppService,
  AppServiceCreate,
  AppServiceDetail,
  AppServiceHosting,
  AppServiceUpdate,
  BillingStribePaymentMethodCreate,
  BillingStripeCreateSubscription,
  BodyAnalyzePcapApiV1AnalyzePcapPost,
  BodyLoginApiV1TokenPost,
  BodyNewIamUserSetupPasswordApiV1NewIamUserSetPasswordPost,
  BodyResetPasswordApiV1ResetPasswordPost,
  BodySetCpeDenialOfServiceThresholdsApiV1SetCpeDenialOfServiceThresholdsPost,
  BodyUserAgentSigninApiV1UserAgentSigninPost,
  CertificateDisableRequest,
  CertificateUploadRequest,
  Contact,
  ContactCreate,
  Cpe,
  CpeCreate,
  CpeDetail,
  CpeEditNetwork,
  CpeInfoUpdate,
  DHCPRelay,
  DosStats,
  Entity,
  EntityCreate,
  Ep,
  EpCreate,
  EpDetail,
  EpGroup,
  EpNode,
  EpNodeCreate,
  EpNodeDetail,
  EpNodeGroup,
  EpNodeGroupCreate,
  EpNodeGroupDetail,
  EpProxying,
  EpUpdate,
  EpUserSession,
  GetAppNameByIP,
  HTTPValidationError,
  Hosting,
  HostingType,
  IPAppName,
  IamRole,
  IamUser,
  IamUserCreate,
  IamUserUpdate,
  IperfServer,
  LANInterface,
  Metro,
  MetroCreate,
  MetroDetail,
  MetroInfoUpdate,
  MetroLoopbackTest,
  MetroOamEdit,
  MetroPerformanceTest,
  MfaType,
  NodeConnStatus,
  PaymentProvider,
  PerfTestSchedule,
  S3UploadUrl,
  ServiceNode,
  ServiceNodeCreate,
  ServiceNodeDetail,
  ServiceNodeGroup,
  ServiceNodeGroupCreate,
  SetNodeFormFactor,
  UserAgent,
  UserAgentCreate,
  VRRPConfig,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Api<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags common, logging
   * @name CreateAccountApiV1CreateAccountPost
   * @summary Create Account
   * @request POST:/create-account
   */
  createAccountApiV1CreateAccountPost = (data: AccountCreate, params: RequestParams = {}) =>
    this.request<Account, HTTPValidationError>({
      path: `/create-account`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name ListAccountApiV1ListAccountGet
   * @summary List Account
   * @request GET:/list-account
   * @secure
   */
  listAccountApiV1ListAccountGet = (
    query?: {
      /** Username */
      username?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<(Account | IamUser | (Account & IamUser))[], HTTPValidationError>({
      path: `/list-account`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name DeleteAccountApiV1DeleteAccountPost
   * @summary Delete Account
   * @request POST:/delete-account
   * @secure
   */
  deleteAccountApiV1DeleteAccountPost = (
    query: {
      /** Username */
      username: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Account, HTTPValidationError>({
      path: `/delete-account`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name RemoveAccountApiV1RemoveAccountPost
   * @summary Remove Account
   * @request POST:/remove-account
   * @secure
   */
  removeAccountApiV1RemoveAccountPost = (
    query: {
      /** Username */
      username: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-account`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name UpdateAccountApiV1UpdateAccountPost
   * @summary Update Account
   * @request POST:/update-account
   * @secure
   */
  updateAccountApiV1UpdateAccountPost = (data: AccountUpdate, params: RequestParams = {}) =>
    this.request<Account, HTTPValidationError>({
      path: `/update-account`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetAccountSummaryApiV1GetAccountSummaryGet
   * @summary Get Account Summary
   * @request GET:/get-account-summary
   * @secure
   */
  getAccountSummaryApiV1GetAccountSummaryGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/get-account-summary`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags internal, accountowner, logging
   * @name CleanupAccountApiV1CleanupAccountPost
   * @summary Cleanup Account
   * @request POST:/cleanup-account
   * @secure
   */
  cleanupAccountApiV1CleanupAccountPost = (
    query: {
      /** Target Account Id */
      target_account_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/cleanup-account`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name AccountEnableMfaApiV1AccountEnableMfaPost
   * @summary Account Enable Mfa
   * @request POST:/account-enable-mfa
   * @secure
   */
  accountEnableMfaApiV1AccountEnableMfaPost = (
    query: {
      /** An enumeration. */
      type: MfaType;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-enable-mfa`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name AccountDisableMfaApiV1AccountDisableMfaPost
   * @summary Account Disable Mfa
   * @request POST:/account-disable-mfa
   * @secure
   */
  accountDisableMfaApiV1AccountDisableMfaPost = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/account-disable-mfa`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags internal, accountowner, logging
   * @name AccountEnableTrialApiV1AccountEnableTrialPost
   * @summary Account Enable Trial
   * @request POST:/account-enable-trial
   * @secure
   */
  accountEnableTrialApiV1AccountEnableTrialPost = (
    query: {
      /** Target Account Id */
      target_account_id: string;
      /** Trial Period Days */
      trial_period_days: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-enable-trial`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags internal, accountowner, logging
   * @name AccountDisableTrialApiV1AccountDisableTrialPost
   * @summary Account Disable Trial
   * @request POST:/account-disable-trial
   * @secure
   */
  accountDisableTrialApiV1AccountDisableTrialPost = (
    query: {
      /** Target Account Id */
      target_account_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-disable-trial`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name AccountGetLogoApiV1AccountGetLogoGet
   * @summary Account Get Logo
   * @request GET:/account-get-logo
   * @secure
   */
  accountGetLogoApiV1AccountGetLogoGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/account-get-logo`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin
   * @name AccountSetLogoApiV1AccountSetLogoPost
   * @summary Account Set Logo
   * @request POST:/account-set-logo
   * @secure
   */
  accountSetLogoApiV1AccountSetLogoPost = (
    query?: {
      /** Logo Url */
      logo_url?: string;
      /** Account Id */
      account_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/account-set-logo`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name CreateAccountIdpApiV1CreateAccountIdpPost
   * @summary Create Account Idp
   * @request POST:/create-account-idp
   * @secure
   */
  createAccountIdpApiV1CreateAccountIdpPost = (
    data: AccountIdpCreate,
    params: RequestParams = {},
  ) =>
    this.request<AccountIdp, HTTPValidationError>({
      path: `/create-account-idp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner
   * @name GetAccountIdpApiV1GetAccountIdpGet
   * @summary Get Account Idp
   * @request GET:/get-account-idp
   * @secure
   */
  getAccountIdpApiV1GetAccountIdpGet = (params: RequestParams = {}) =>
    this.request<AccountIdp[], any>({
      path: `/get-account-idp`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name RemoveAccountIdpApiV1RemoveAccountIdpPost
   * @summary Remove Account Idp
   * @request POST:/remove-account-idp
   * @secure
   */
  removeAccountIdpApiV1RemoveAccountIdpPost = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/remove-account-idp`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name UpdateAccountIdpApiV1UpdateAccountIdpPost
   * @summary Update Account Idp
   * @request POST:/update-account-idp
   * @secure
   */
  updateAccountIdpApiV1UpdateAccountIdpPost = (
    data: AccountIdpUpdate,
    params: RequestParams = {},
  ) =>
    this.request<AccountIdp, HTTPValidationError>({
      path: `/update-account-idp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name SetAccountOpsApiV1SetAccountOpsPost
   * @summary Set Account Ops
   * @request POST:/set-account-ops
   * @secure
   */
  setAccountOpsApiV1SetAccountOpsPost = (data: AccountOpsSet, params: RequestParams = {}) =>
    this.request<AccountOps, HTTPValidationError>({
      path: `/set-account-ops`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin
   * @name GetAccountOpsApiV1GetAccountOpsGet
   * @summary Get Account Ops
   * @request GET:/get-account-ops
   * @secure
   */
  getAccountOpsApiV1GetAccountOpsGet = (params: RequestParams = {}) =>
    this.request<AccountOps[], any>({
      path: `/get-account-ops`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name RemoveAccountOpsApiV1RemoveAccountOpsPost
   * @summary Remove Account Ops
   * @request POST:/remove-account-ops
   * @secure
   */
  removeAccountOpsApiV1RemoveAccountOpsPost = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/remove-account-ops`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Create a new app service. Args: account (models.Account): The account associated with the app service. asc (schemas.AppServiceCreate): The data required to create the app service. db (Session, optional): The database session. Raises: HTTPException: If the app service name is not valid, the protocol is not valid, or an app service with the same name already exists. Returns: models.AppService: The newly created app service.
   *
   * @tags provider, admin, logging
   * @name CreateAppServiceApiV1CreateAppServicePost
   * @summary Create App Service
   * @request POST:/create-app-service
   * @secure
   */
  createAppServiceApiV1CreateAppServicePost = (
    data: AppServiceCreate,
    params: RequestParams = {},
  ) =>
    this.request<AppService, HTTPValidationError>({
      path: `/create-app-service`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Get an app with given app_name and owner_user_name.
   *
   * @tags provider, readonly
   * @name ListAppServiceApiV1ListAppServiceGet
   * @summary List App Service
   * @request GET:/list-app-service
   * @secure
   */
  listAppServiceApiV1ListAppServiceGet = (
    query?: {
      /** App Service Name */
      app_service_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AppService[], HTTPValidationError>({
      path: `/list-app-service`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Remove an app service.
   *
   * @tags provider, admin, logging
   * @name RemoveAppServiceApiV1RemoveAppServicePost
   * @summary Remove App Service
   * @request POST:/remove-app-service
   * @secure
   */
  removeAppServiceApiV1RemoveAppServicePost = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-app-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, readonly
   * @name CheckAppServiceStatusApiV1CheckAppServiceStatusGet
   * @summary Check App Service Status
   * @request GET:/check-app-service-status
   * @secure
   */
  checkAppServiceStatusApiV1CheckAppServiceStatusGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/check-app-service-status`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Return a detailed view of AppService
   *
   * @tags provider, readonly
   * @name GetAppServiceDetailApiV1GetAppServiceDetailGet
   * @summary Get App Service Detail
   * @request GET:/get-app-service-detail
   * @secure
   */
  getAppServiceDetailApiV1GetAppServiceDetailGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AppServiceDetail, HTTPValidationError>({
      path: `/get-app-service-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, readonly
   * @name GetAppServiceEndpointsApiV1GetAppServiceEndpointsGet
   * @summary Get App Service Endpoints
   * @request GET:/get-app-service-endpoints
   * @secure
   */
  getAppServiceEndpointsApiV1GetAppServiceEndpointsGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep[], HTTPValidationError>({
      path: `/get-app-service-endpoints`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, readonly
   * @name GetAppServiceNotificationsApiV1GetAppServiceNotificationsGet
   * @summary Get App Service Notifications
   * @request GET:/get-app-service-notifications
   * @secure
   */
  getAppServiceNotificationsApiV1GetAppServiceNotificationsGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep[], HTTPValidationError>({
      path: `/get-app-service-notifications`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name SetAppServiceNameApiV1SetAppServiceNamePost
   * @summary Set the name of app service, overwrite any existing name
   * @request POST:/set-app-service-name
   * @secure
   */
  setAppServiceNameApiV1SetAppServiceNamePost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** App Service Name */
      app_service_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-app-service-name`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name SetAppServiceDescriptionApiV1SetAppServiceDescriptionPost
   * @summary Set the description of app service, overwrite any existing name
   * @request POST:/set-app-service-description
   * @secure
   */
  setAppServiceDescriptionApiV1SetAppServiceDescriptionPost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Description */
      description: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-app-service-description`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, readonly
   * @name MeasureAppServiceLatencyApiV1MeasureAppServiceLatencyPost
   * @summary Measure the app service latency
   * @request POST:/measure-app-service-latency
   * @secure
   */
  measureAppServiceLatencyApiV1MeasureAppServiceLatencyPost = (
    query: {
      /** App Service Id */
      app_service_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/measure-app-service-latency`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name AppServiceAddHostingApiV1AppServiceAddHostingPost
   * @summary Add a hosting to existing app service
   * @request POST:/app-service-add-hosting
   * @secure
   */
  appServiceAddHostingApiV1AppServiceAddHostingPost = (
    data: AppServiceHosting,
    params: RequestParams = {},
  ) =>
    this.request<AppService, HTTPValidationError>({
      path: `/app-service-add-hosting`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name EditAppServiceApiV1EditAppServicePost
   * @summary Edit App Service
   * @request POST:/edit-app-service
   * @secure
   */
  editAppServiceApiV1EditAppServicePost = (data: AppServiceUpdate, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-app-service`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, readonly
   * @name AppServiceGetHostingApiV1AppServiceGetHostingGet
   * @summary App Service Get Hosting
   * @request GET:/app-service-get-hosting
   * @secure
   */
  appServiceGetHostingApiV1AppServiceGetHostingGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** An enumeration. */
      hosting_type?: HostingType;
    },
    params: RequestParams = {},
  ) =>
    this.request<Hosting[], HTTPValidationError>({
      path: `/app-service-get-hosting`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name AppServiceRemoveHostingApiV1AppServiceRemoveHostingPost
   * @summary Remove a hosting from existing app service
   * @request POST:/app-service-remove-hosting
   * @secure
   */
  appServiceRemoveHostingApiV1AppServiceRemoveHostingPost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Hosting Id */
      hosting_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AppService, HTTPValidationError>({
      path: `/app-service-remove-hosting`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name ResizeAppServiceApiV1ResizeAppServicePost
   * @summary Resize a cloud hosted app service (AWS or Azure)
   * @request POST:/resize-app-service
   * @secure
   */
  resizeAppServiceApiV1ResizeAppServicePost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Hosting Id */
      hosting_id: string;
      /** Direction */
      direction: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/resize-app-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name AppServiceUpdateContactApiV1SetAppServiceContactPost
   * @summary App Service Update Contact
   * @request POST:/set-app-service-contact
   * @secure
   */
  appServiceUpdateContactApiV1SetAppServiceContactPost = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Primary Contact Id */
      primary_contact_id?: string;
      /** Secondary Contact Id */
      secondary_contact_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-app-service-contact`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name ListEpGroupApiV1ListEndpointGroupGet
   * @summary List Ep Group
   * @request GET:/list-endpoint-group
   * @secure
   */
  listEpGroupApiV1ListEndpointGroupGet = (
    query?: {
      /** Ep Group Name */
      ep_group_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpGroup[], HTTPValidationError>({
      path: `/list-endpoint-group`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Create an endpoint with given ep_name, owner_user_name and ep_type.
   *
   * @tags consumer, admin, logging
   * @name CreateEpApiV1CreateEndpointPost
   * @summary Create Ep
   * @request POST:/create-endpoint
   * @secure
   */
  createEpApiV1CreateEndpointPost = (data: EpCreate, params: RequestParams = {}) =>
    this.request<Ep, HTTPValidationError>({
      path: `/create-endpoint`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name ListEpApiV1ListEndpointGet
   * @summary List Ep
   * @request GET:/list-endpoint
   * @secure
   */
  listEpApiV1ListEndpointGet = (
    query?: {
      /** App Service Id */
      app_service_id?: string;
      /** Ep Node Id */
      ep_node_id?: string;
      /** Ep Name */
      ep_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep[], HTTPValidationError>({
      path: `/list-endpoint`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Get an endpoint with given ep_name, owner_user_name and ep_type.
   *
   * @tags consumer, readonly
   * @name ListEndpointDashboardApiV1ListEndpointDashboardGet
   * @summary List Endpoint Dashboard
   * @request GET:/list-endpoint-dashboard
   * @secure
   */
  listEndpointDashboardApiV1ListEndpointDashboardGet = (
    query?: {
      /** App Service Id */
      app_service_id?: string;
      /** Ep Node Id */
      ep_node_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep[], HTTPValidationError>({
      path: `/list-endpoint-dashboard`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name DeleteEpApiV1DeleteEndpointPost
   * @summary Delete Ep
   * @request POST:/delete-endpoint
   * @secure
   */
  deleteEpApiV1DeleteEndpointPost = (
    query: {
      /** Ep Name */
      ep_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Ep, HTTPValidationError>({
      path: `/delete-endpoint`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name RemoveEpApiV1RemoveEndpointPost
   * @summary Remove Ep
   * @request POST:/remove-endpoint
   * @secure
   */
  removeEpApiV1RemoveEndpointPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-endpoint`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name ApproveEpApiV1ApproveEndpointPost
   * @summary Approve Ep
   * @request POST:/approve-endpoint
   * @secure
   */
  approveEpApiV1ApproveEndpointPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/approve-endpoint`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name RejectEpApiV1RejectEndpointPost
   * @summary Reject Ep
   * @request POST:/reject-endpoint
   */
  rejectEpApiV1RejectEndpointPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reject-endpoint`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name GetEndpointDetailApiV1GetEndpointDetailGet
   * @summary Get Endpoint Detail
   * @request GET:/get-endpoint-detail
   * @secure
   */
  getEndpointDetailApiV1GetEndpointDetailGet = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpDetail, HTTPValidationError>({
      path: `/get-endpoint-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Measure endpoint latency. Returns a dictionary in the following form { "state":"UP" "details": None, "min": "MIN_LATENCY", "avg": "AVERAGE_LATENCY", "max": "MAX_LATENCY" } if state is DOWN, the key "details" will have troubleshooting tips.
   *
   * @tags consumer, readonly
   * @name MeasureEpLatencyApiV1MeasureEndpointLatencyPost
   * @summary Measure Ep Latency
   * @request POST:/measure-endpoint-latency
   * @secure
   */
  measureEpLatencyApiV1MeasureEndpointLatencyPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/measure-endpoint-latency`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Reset an endpoint. Used for troubleshooting or recovery from failure.
   *
   * @tags consumer, admin, logging
   * @name ResetEndpointApiV1ResetEndpointPost
   * @summary Reset Endpoint
   * @request POST:/reset-endpoint
   * @secure
   */
  resetEndpointApiV1ResetEndpointPost = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reset-endpoint`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name SetEndpointNameApiV1SetEndpointNamePost
   * @summary Set the name of endpoint, overwrite any existing name
   * @request POST:/set-endpoint-name
   * @secure
   */
  setEndpointNameApiV1SetEndpointNamePost = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Ep Name */
      ep_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-endpoint-name`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name SetEndpointDescriptionApiV1SetEndpointDescriptionPost
   * @summary Update endpoint description, overwrite any existing ones
   * @request POST:/set-endpoint-description
   * @secure
   */
  setEndpointDescriptionApiV1SetEndpointDescriptionPost = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Description */
      description: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-endpoint-description`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name GetEndpointSessionsApiV1GetEndpointSessionsGet
   * @summary List all sessions on an endpoint
   * @request GET:/get-endpoint-sessions
   * @secure
   */
  getEndpointSessionsApiV1GetEndpointSessionsGet = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpUserSession[], HTTPValidationError>({
      path: `/get-endpoint-sessions`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name EditEndpointApiV1EditEndpointPost
   * @summary Edit Endpoint
   * @request POST:/edit-endpoint
   * @secure
   */
  editEndpointApiV1EditEndpointPost = (data: EpUpdate, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-endpoint`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name ResizeEndpointThroughputApiV1ResizeEndpointThroughputPost
   * @summary Resize Endpoint Throughput
   * @request POST:/resize-endpoint-throughput
   * @secure
   */
  resizeEndpointThroughputApiV1ResizeEndpointThroughputPost = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Direction */
      direction: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/resize-endpoint-throughput`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name EndpointUpdateContactApiV1SetEndpointContactPost
   * @summary Endpoint Update Contact
   * @request POST:/set-endpoint-contact
   * @secure
   */
  endpointUpdateContactApiV1SetEndpointContactPost = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Primary Contact Id */
      primary_contact_id?: string;
      /** Secondary Contact Id */
      secondary_contact_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-endpoint-contact`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name ConfigureEndpointProxyingApiV1ConfigureEndpointProxyingPost
   * @summary Configure Endpoint Proxying
   * @request POST:/configure-endpoint-proxying
   * @secure
   */
  configureEndpointProxyingApiV1ConfigureEndpointProxyingPost = (
    data: EpProxying,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-endpoint-proxying`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Create a service node group with given account_id.
   *
   * @tags provider, admin, logging
   * @name CreateServiceNodeGroupApiV1CreateServiceNodeGroupPost
   * @summary Create Service Node Group
   * @request POST:/create-service-node-group
   * @secure
   */
  createServiceNodeGroupApiV1CreateServiceNodeGroupPost = (
    data: ServiceNodeGroupCreate,
    params: RequestParams = {},
  ) =>
    this.request<ServiceNodeGroup, HTTPValidationError>({
      path: `/create-service-node-group`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description List service node groups under an account.
   *
   * @tags provider, readonly
   * @name ListServiceNodeGroupApiV1ListServiceNodeGroupGet
   * @summary List Service Node Group
   * @request GET:/list-service-node-group
   * @secure
   */
  listServiceNodeGroupApiV1ListServiceNodeGroupGet = (
    query?: {
      /** Service Node Group Name */
      service_node_group_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ServiceNodeGroup[], HTTPValidationError>({
      path: `/list-service-node-group`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Remove service node group
   *
   * @tags provider, admin, logging
   * @name RemoveServiceNodeGroupApiV1RemoveServiceNodeGroupPost
   * @summary Remove Service Node Group
   * @request POST:/remove-service-node-group
   * @secure
   */
  removeServiceNodeGroupApiV1RemoveServiceNodeGroupPost = (
    query: {
      /** Service Node Group Id */
      service_node_group_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-service-node-group`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Create a service node with given account_id.
   *
   * @tags provider, admin, logging
   * @name CreateServiceNodeApiV1CreateServiceNodePost
   * @summary Create Service Node
   * @request POST:/create-service-node
   * @secure
   */
  createServiceNodeApiV1CreateServiceNodePost = (
    data: ServiceNodeCreate,
    params: RequestParams = {},
  ) =>
    this.request<ServiceNode, HTTPValidationError>({
      path: `/create-service-node`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description List service nodes under an account.
   *
   * @tags provider, readonly
   * @name ListServiceNodesApiV1ListServiceNodeGet
   * @summary List Service Nodes
   * @request GET:/list-service-node
   * @secure
   */
  listServiceNodesApiV1ListServiceNodeGet = (
    query?: {
      /** Service Node Group Id */
      service_node_group_id?: string;
      /** Service Node Name */
      service_node_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ServiceNode[], HTTPValidationError>({
      path: `/list-service-node`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Remove service node
   *
   * @tags provider, admin, logging
   * @name RemoveServiceNodeApiV1RemoveServiceNodePost
   * @summary Remove Service Node
   * @request POST:/remove-service-node
   * @secure
   */
  removeServiceNodeApiV1RemoveServiceNodePost = (
    query: {
      /** Service Node Id */
      service_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-service-node`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Prepare the OVA for a service node
   *
   * @tags provider, admin, logging
   * @name PrepareSnOvaApiV1PrepareSnOvaGet
   * @summary Prepare Sn Ova
   * @request GET:/prepare-sn-ova
   * @secure
   */
  prepareSnOvaApiV1PrepareSnOvaGet = (
    query: {
      /** Service Node Id */
      service_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/prepare-sn-ova`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Get service node detail info
   *
   * @tags provider, readonly
   * @name GetServiceNodeDetailApiV1GetServiceNodeDetailGet
   * @summary Get Service Node Detail
   * @request GET:/get-service-node-detail
   * @secure
   */
  getServiceNodeDetailApiV1GetServiceNodeDetailGet = (
    query: {
      /** Service Node Id */
      service_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ServiceNodeDetail, HTTPValidationError>({
      path: `/get-service-node-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name SetServiceNodeFormFactorApiV1SetServiceNodeFormFactorPost
   * @summary Set Service Node Form Factor
   * @request POST:/set-service-node-form-factor
   * @secure
   */
  setServiceNodeFormFactorApiV1SetServiceNodeFormFactorPost = (
    data: SetNodeFormFactor,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-service-node-form-factor`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Return the list of connected endpoints on an appservice gateway.
   *
   * @tags provider, readonly
   * @name GetConnectedEndpointsApiV1GetConnectedEndpointsGet
   * @summary Get Connected Endpoints
   * @request GET:/get-connected-endpoints
   * @secure
   */
  getConnectedEndpointsApiV1GetConnectedEndpointsGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-connected-endpoints`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Upload certificate and key for a service node group
   *
   * @tags provider, admin, logging
   * @name EnableExternalCertificateApiV1EnableExternalCertificatePost
   * @summary Enable External Certificate
   * @request POST:/enable-external-certificate
   * @secure
   */
  enableExternalCertificateApiV1EnableExternalCertificatePost = (
    data: CertificateUploadRequest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/enable-external-certificate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags provider, admin, logging
   * @name DisableExternalCertificateApiV1DisableExternalCertificatePost
   * @summary Disable External Certificate
   * @request POST:/disable-external-certificate
   * @secure
   */
  disableExternalCertificateApiV1DisableExternalCertificatePost = (
    data: CertificateDisableRequest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/disable-external-certificate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common
   * @name LoginApiV1TokenPost
   * @summary Login
   * @request POST:/token
   */
  loginApiV1TokenPost = (data: BodyLoginApiV1TokenPost, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/token`,
      method: 'POST',
      body: data,
      type: ContentType.UrlEncoded,
      format: 'json',
      ...params,
    });
  /**
   * @description Triggers forgot password mechanism for a user.
   *
   * @tags common
   * @name ForgotPasswordApiV1ForgotPasswordPost
   * @summary Trigger forgot password mechanism for a user
   * @request POST:/forgot-password
   */
  forgotPasswordApiV1ForgotPasswordPost = (
    query: {
      /** Email */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/forgot-password`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common
   * @name ResetPasswordTemplateApiV1ResetPasswordTemplateGet
   * @summary Reset password for an account
   * @request GET:/reset-password-template
   */
  resetPasswordTemplateApiV1ResetPasswordTemplateGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/reset-password-template`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common
   * @name ResetPasswordApiV1ResetPasswordPost
   * @summary Reset password for an account
   * @request POST:/reset-password
   */
  resetPasswordApiV1ResetPasswordPost = (
    data: BodyResetPasswordApiV1ResetPasswordPost,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reset-password`,
      method: 'POST',
      body: data,
      type: ContentType.UrlEncoded,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common
   * @name AcsApiV1AcsPost
   * @summary Callback from Idp to process SAML response
   * @request POST:/acs
   */
  acsApiV1AcsPost = (params: RequestParams = {}) =>
    this.request<any, void>({
      path: `/acs`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetNetStatsApiV1GetNetStatsGet
   * @summary Get Net Stats
   * @request GET:/get-net-stats
   * @secure
   */
  getNetStatsApiV1GetNetStatsGet = (
    query: {
      /** Ids */
      ids: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
      /** App Service Id */
      app_service_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-net-stats`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetNodeMetricsApiV1GetNodeMetricsGet
   * @summary Get Node Metrics
   * @request GET:/get-node-metrics
   * @secure
   */
  getNodeMetricsApiV1GetNodeMetricsGet = (
    query: {
      /** Id */
      id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-node-metrics`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetTopTalkerEpApiV1GetTopTalkerEpGet
   * @summary Get Top Talker Ep
   * @request GET:/get-top-talker-ep
   * @secure
   */
  getTopTalkerEpApiV1GetTopTalkerEpGet = (
    query: {
      /** App Service Id */
      app_service_id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-top-talker-ep`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetEpSessionsApiV1GetEpSessionsGet
   * @summary Get Ep Sessions
   * @request GET:/get-ep-sessions
   * @secure
   */
  getEpSessionsApiV1GetEpSessionsGet = (
    query: {
      /** Ep Id */
      ep_id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-ep-sessions`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Create or update a record mapping an IP CIDR block to an application name.
   *
   * @tags common, readonly
   * @name InsertIpAppnameApiV1InsertIpAppnamePost
   * @summary Insert Ip Appname
   * @request POST:/insert-ip-appname
   * @secure
   */
  insertIpAppnameApiV1InsertIpAppnamePost = (data: IPAppName, params: RequestParams = {}) =>
    this.request<IPAppName, HTTPValidationError>({
      path: `/insert-ip-appname`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Delete a record mapping an IP CIDR block to an application name.
   *
   * @tags common, readonly
   * @name RemoveIpAppnameApiV1RemoveIpAppnamePost
   * @summary Remove Ip Appname
   * @request POST:/remove-ip-appname
   * @secure
   */
  removeIpAppnameApiV1RemoveIpAppnamePost = (
    query: {
      /** App Name */
      app_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-ip-appname`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Get a record mapping an IP CIDR block to an application name.
   *
   * @tags common, readonly
   * @name GetCidrByAppnameApiV1GetCidrByAppnameGet
   * @summary Get Cidr By Appname
   * @request GET:/get-cidr-by-appname
   * @secure
   */
  getCidrByAppnameApiV1GetCidrByAppnameGet = (
    query: {
      /** App Name */
      app_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<IPAppName, HTTPValidationError>({
      path: `/get-cidr-by-appname`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Get an application name based on IP address
   *
   * @tags common, readonly
   * @name GetAppnameByIpApiV1GetAppnameByIpGet
   * @summary Get Appname By Ip
   * @request GET:/get-appname-by-ip
   * @secure
   */
  getAppnameByIpApiV1GetAppnameByIpGet = (data: GetAppNameByIP, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/get-appname-by-ip`,
      method: 'GET',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name PerformFlowAnalysisApiV1PerformFlowAnalysisPost
   * @summary Perform Flow Analysis
   * @request POST:/perform-flow-analysis
   * @secure
   */
  performFlowAnalysisApiV1PerformFlowAnalysisPost = (data: object, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/perform-flow-analysis`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description The Web API to get the node connection up/down history and uptime percentage
   *
   * @tags common, admin
   * @name GetNodeConnStatusApiV1GetNodeConnStatusGet
   * @summary Get Node Conn Status
   * @request GET:/get-node-conn-status
   * @secure
   */
  getNodeConnStatusApiV1GetNodeConnStatusGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<NodeConnStatus, HTTPValidationError>({
      path: `/get-node-conn-status`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description The Web API to get the node DOS stats
   *
   * @tags common, readonly
   * @name GetDosStatsApiV1GetDosStatsGet
   * @summary Get Dos Stats
   * @request GET:/get-dos-stats
   * @secure
   */
  getDosStatsApiV1GetDosStatsGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<DosStats, HTTPValidationError>({
      path: `/get-dos-stats`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description List AWS regions
   *
   * @tags common
   * @name ListAwsRegionsApiV1ListAwsRegionsGet
   * @summary List Aws Regions
   * @request GET:/list-aws-regions
   */
  listAwsRegionsApiV1ListAwsRegionsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/list-aws-regions`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * @description List Azure regions
   *
   * @tags common
   * @name ListAzureRegionsApiV1ListAzureRegionsGet
   * @summary List Azure Regions
   * @request GET:/list-azure-regions
   */
  listAzureRegionsApiV1ListAzureRegionsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/list-azure-regions`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * @description Get cloud init file for a node.
   *
   * @tags provider, admin
   * @name GenerateNodeCloudInitDataApiV1GenerateNodeCloudInitDataPost
   * @summary Generate Node Cloud Init Data
   * @request POST:/generate-node-cloud-init-data
   * @secure
   */
  generateNodeCloudInitDataApiV1GenerateNodeCloudInitDataPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/generate-node-cloud-init-data`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description If the VGW is not ready, proceed with creating the VPC, CGW, VGW, site-to-site VPN and ec2 instance. If the VGW has been created but the EC2 instance has not, proceed with creating ec2 instance. Then it will Generate a site-to-site VPN configuration for the hosted service node.
   *
   * @tags provider, admin
   * @name GenerateHsnVpnConfigApiV1GenerateHsnVpnConfigPost
   * @summary Generate Hsn Vpn Config
   * @request POST:/generate-hsn-vpn-config
   * @secure
   */
  generateHsnVpnConfigApiV1GenerateHsnVpnConfigPost = (
    data: SetNodeFormFactor,
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/generate-hsn-vpn-config`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Download site-to-site VPN cfg file
   *
   * @tags provider, admin
   * @name DownloadHsnVpnConfigApiV1DownloadHsnVpnConfigFileNameGet
   * @summary Download Hsn Vpn Config
   * @request GET:/download-hsn-vpn-config/{file_name}
   */
  downloadHsnVpnConfigApiV1DownloadHsnVpnConfigFileNameGet = (
    fileName: string,
    params: RequestParams = {},
  ) =>
    this.request<void, HTTPValidationError>({
      path: `/download-hsn-vpn-config/${fileName}`,
      method: 'GET',
      ...params,
    });
  /**
   * @description Run health check on a connected node.
   *
   * @tags common, readonly
   * @name RunHealthCheckApiV1RunHealthCheckGet
   * @summary Run Health Check
   * @request GET:/run-health-check
   * @secure
   */
  runHealthCheckApiV1RunHealthCheckGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/run-health-check`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Run diagnostics on a connected node.
   *
   * @tags internal, accountmaster
   * @name RunDiagApiV1RunDiagGet
   * @summary Run Diag
   * @request GET:/run-diag
   * @secure
   */
  runDiagApiV1RunDiagGet = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/run-diag`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Run diagnostics on a connected node.
   *
   * @tags internal, accountmaster
   * @name UploadDiagApiV1UploadDiagPost
   * @summary Upload Diag
   * @request POST:/upload-diag
   * @secure
   */
  uploadDiagApiV1UploadDiagPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/upload-diag`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Upgrade a node.
   *
   * @tags internal, accountmaster, logging
   * @name UpgradeNodeApiV1UpgradeNodePost
   * @summary Upgrade Node
   * @request POST:/upgrade-node
   * @secure
   */
  upgradeNodeApiV1UpgradeNodePost = (
    query: {
      /** Node Id */
      node_id: string;
      /** Url */
      url: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/upgrade-node`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Reset a node. A reset will recompute config  on the controller and push to node. If hard is True, it will also reboot the node.
   *
   * @tags common, logging
   * @name ResetNodeApiV1ResetNodePost
   * @summary Reset Node
   * @request POST:/reset-node
   * @secure
   */
  resetNodeApiV1ResetNodePost = (
    query: {
      /** Node Id */
      node_id: string;
      /** Hard */
      hard: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reset-node`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Enable SSH access on a node from diag server.
   *
   * @tags internal, accountmaster, logging
   * @name EnableRemoteAccessApiV1EnableRemoteAccessPost
   * @summary Enable Remote Access
   * @request POST:/enable-remote-access
   * @secure
   */
  enableRemoteAccessApiV1EnableRemoteAccessPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/enable-remote-access`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Disable remote access on a node.
   *
   * @tags internal, accountmaster, logging
   * @name DisableRemoteAccessApiV1DisableRemoteAccessPost
   * @summary Disable Remote Access
   * @request POST:/disable-remote-access
   * @secure
   */
  disableRemoteAccessApiV1DisableRemoteAccessPost = (
    query: {
      /** Node Id */
      node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/disable-remote-access`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Reset ports on a CPE or Metro device.
   *
   * @tags common, logging
   * @name ResetInterfaceApiV1ResetInterfacePost
   * @summary Reset Interface
   * @request POST:/reset-interface
   * @secure
   */
  resetInterfaceApiV1ResetInterfacePost = (
    query: {
      /** Node Id */
      node_id: string;
      /** Interface */
      interface: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/reset-interface`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Run ping on a Node.
   *
   * @tags common, readonly
   * @name RunPingApiV1RunPingGet
   * @summary Run Ping
   * @request GET:/run-ping
   * @secure
   */
  runPingApiV1RunPingGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Ip Address */
      ip_address: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/run-ping`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Run traceroute on a Node.
   *
   * @tags common, readonly
   * @name RunTracerouteApiV1RunTracerouteGet
   * @summary Run Traceroute
   * @request GET:/run-traceroute
   * @secure
   */
  runTracerouteApiV1RunTracerouteGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Ip Address */
      ip_address: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/run-traceroute`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Run a command on a Node.
   *
   * @tags internal, accountmaster, logging
   * @name RunCmdApiV1RunCmdPost
   * @summary Run Cmd
   * @request POST:/run-cmd
   * @secure
   */
  runCmdApiV1RunCmdPost = (
    query: {
      /** Node Id */
      node_id: string;
      /** Command */
      command: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/run-cmd`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name SubscribeApiV1SubscribePost
   * @summary Subscribe
   * @request POST:/subscribe
   */
  subscribeApiV1SubscribePost = (
    query?: {
      /** Provider */
      provider?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void | HTTPValidationError>({
      path: `/subscribe`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetStripePublishableKeyApiV1GetStripePublishableKeyGet
   * @summary Get Stripe Publishable Key
   * @request GET:/get-stripe-publishable-key
   * @secure
   */
  getStripePublishableKeyApiV1GetStripePublishableKeyGet = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/get-stripe-publishable-key`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name CreateStripePaymentApiV1CreateStripePaymentPost
   * @summary Create Stripe Payment
   * @request POST:/create-stripe-payment
   * @secure
   */
  createStripePaymentApiV1CreateStripePaymentPost = (
    data: BillingStribePaymentMethodCreate,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/create-stripe-payment`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name ReportUsageToStripeApiV1ReportUsageToStripePost
   * @summary Report Usage To Stripe
   * @request POST:/report-usage-to-stripe
   * @secure
   */
  reportUsageToStripeApiV1ReportUsageToStripePost = (
    query: {
      /** Product Name */
      product_name: string;
      /** Unit Count */
      unit_count: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/report-usage-to-stripe`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner
   * @name GetBillingsApiV1GetBillingsGet
   * @summary Get Billings
   * @request GET:/get-billings
   * @secure
   */
  getBillingsApiV1GetBillingsGet = (params: RequestParams = {}) =>
    this.request<any[], any>({
      path: `/get-billings`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name SetPreferredBillingApiV1SetPreferredBillingPost
   * @summary Set Preferred Billing
   * @request POST:/set-preferred-billing
   * @secure
   */
  setPreferredBillingApiV1SetPreferredBillingPost = (
    query: {
      /** An enumeration. */
      provider: PaymentProvider;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-preferred-billing`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name SetupBillingStripeSubscriptionApiV1SetupBillingStripeSubscriptionPost
   * @summary Setup Billing Stripe Subscription
   * @request POST:/setup-billing-stripe-subscription
   * @secure
   */
  setupBillingStripeSubscriptionApiV1SetupBillingStripeSubscriptionPost = (
    data: BillingStripeCreateSubscription,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/setup-billing-stripe-subscription`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, accountowner, logging
   * @name RemoveBillingApiV1RemoveBillingPost
   * @summary Remove Billing
   * @request POST:/remove-billing
   * @secure
   */
  removeBillingApiV1RemoveBillingPost = (
    query: {
      /** An enumeration. */
      provider: PaymentProvider;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-billing`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name CreateUserAgentApiV1CreateUserAgentPost
   * @summary Create User Agent
   * @request POST:/create-user-agent
   * @secure
   */
  createUserAgentApiV1CreateUserAgentPost = (data: UserAgentCreate, params: RequestParams = {}) =>
    this.request<UserAgent, HTTPValidationError>({
      path: `/create-user-agent`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name ListUserAgentApiV1ListUserAgentGet
   * @summary List User Agent
   * @request GET:/list-user-agent
   * @secure
   */
  listUserAgentApiV1ListUserAgentGet = (
    query?: {
      /** Email */
      email?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<UserAgent[], HTTPValidationError>({
      path: `/list-user-agent`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name RemoveUserAgentApiV1RemoveUserAgentPost
   * @summary Remove User Agent
   * @request POST:/remove-user-agent
   * @secure
   */
  removeUserAgentApiV1RemoveUserAgentPost = (
    query: {
      /** User Agent Id */
      user_agent_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-user-agent`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name LinkUserAgentToEpApiV1LinkUserAgentToEpPost
   * @summary Link User Agent To Ep
   * @request POST:/link-user-agent-to-ep
   * @secure
   */
  linkUserAgentToEpApiV1LinkUserAgentToEpPost = (
    query: {
      /** User Agent Id */
      user_agent_id: string;
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/link-user-agent-to-ep`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name UnlinkUserAgentFromEpApiV1UnlinkUserAgentFromEpPost
   * @summary Unlink User Agent From Ep
   * @request POST:/unlink-user-agent-from-ep
   * @secure
   */
  unlinkUserAgentFromEpApiV1UnlinkUserAgentFromEpPost = (
    query: {
      /** User Agent Id */
      user_agent_id: string;
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/unlink-user-agent-from-ep`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer
   * @name UserAgentGetOtpApiV1UserAgentGetOtpGet
   * @summary User Agent Get Otp
   * @request GET:/user-agent-get-otp
   */
  userAgentGetOtpApiV1UserAgentGetOtpGet = (
    query: {
      /** Email */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/user-agent-get-otp`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer
   * @name UserAgentApiV1UserAgentGet
   * @summary User Agent
   * @request GET:/user-agent
   */
  userAgentApiV1UserAgentGet = (
    query: {
      /** Session Id */
      session_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/user-agent`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer
   * @name UserAgentSigninApiV1UserAgentSigninPost
   * @summary User Agent Signin
   * @request POST:/user-agent-signin
   */
  userAgentSigninApiV1UserAgentSigninPost = (
    data: BodyUserAgentSigninApiV1UserAgentSigninPost,
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/user-agent-signin`,
      method: 'POST',
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer
   * @name UserAgentConnectApiV1UserAgentConnectGet
   * @summary User Agent Connect
   * @request GET:/user-agent-connect
   */
  userAgentConnectApiV1UserAgentConnectGet = (
    query: {
      /** Email */
      email: string;
      /** Otp */
      otp: string;
      /** Session Id */
      session_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, HTTPValidationError>({
      path: `/user-agent-connect`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer
   * @name UserAgentGetProfileApiV1UserAgentGetProfileGet
   * @summary User Agent Get Profile
   * @request GET:/user-agent-get-profile
   */
  userAgentGetProfileApiV1UserAgentGetProfileGet = (
    query: {
      /** Session Id */
      session_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/user-agent-get-profile`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name UserAgentGetLinkedEpApiV1UserAgentGetLinkedEpGet
   * @summary User Agent Get Linked Ep
   * @request GET:/user-agent-get-linked-ep
   * @secure
   */
  userAgentGetLinkedEpApiV1UserAgentGetLinkedEpGet = (
    query: {
      /** User Agent Id */
      user_agent_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/user-agent-get-linked-ep`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name UserAgentGetUnlinkedEpApiV1UserAgentGetUnlinkedEpGet
   * @summary User Agent Get Unlinked Ep
   * @request GET:/user-agent-get-unlinked-ep
   * @secure
   */
  userAgentGetUnlinkedEpApiV1UserAgentGetUnlinkedEpGet = (
    query?: {
      /** User Agent Id */
      user_agent_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/user-agent-get-unlinked-ep`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer
   * @name UserAgentVerifyProfileIdApiV1UserAgentVerifyProfileIdGet
   * @summary User Agent Verify Profile Id
   * @request GET:/user-agent-verify-profile-id
   */
  userAgentVerifyProfileIdApiV1UserAgentVerifyProfileIdGet = (
    query: {
      /** Email */
      email: string;
      /** Profile Id */
      profile_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/user-agent-verify-profile-id`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name ContactTypesApiV1ContactTypesGet
   * @summary Contact Types
   * @request GET:/contact-types
   */
  contactTypesApiV1ContactTypesGet = (params: RequestParams = {}) =>
    this.request<any[], any>({
      path: `/contact-types`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name CreateContactApiV1CreateContactPost
   * @summary Create Contact
   * @request POST:/create-contact
   * @secure
   */
  createContactApiV1CreateContactPost = (data: ContactCreate, params: RequestParams = {}) =>
    this.request<Contact, HTTPValidationError>({
      path: `/create-contact`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetContactApiV1GetContactGet
   * @summary Get Contact
   * @request GET:/get-contact
   * @secure
   */
  getContactApiV1GetContactGet = (
    query?: {
      /** Email */
      email?: string;
      /** Entity Id */
      entity_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Contact[], HTTPValidationError>({
      path: `/get-contact`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetContactByEpIdApiV1GetContactByEpIdGet
   * @summary Get Contact By Ep Id
   * @request GET:/get-contact-by-ep-id
   * @secure
   */
  getContactByEpIdApiV1GetContactByEpIdGet = (
    query: {
      /** Ep Id */
      ep_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/get-contact-by-ep-id`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name RemoveContactApiV1RemoveContactPost
   * @summary Remove Contact
   * @request POST:/remove-contact
   * @secure
   */
  removeContactApiV1RemoveContactPost = (
    query: {
      /** Contact Id */
      contact_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-contact`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name UpdateContactApiV1UpdateContactPost
   * @summary Update Contact
   * @request POST:/update-contact
   * @secure
   */
  updateContactApiV1UpdateContactPost = (
    query: {
      /** Contact Id */
      contact_id: string;
      /** Last Name */
      last_name?: string;
      /** First Name */
      first_name?: string;
      /** Email */
      email?: string;
      /** Address */
      address?: string;
      /** Phone */
      phone?: string;
      /** Company Name */
      company_name?: string;
      /** Contact Type */
      contact_type?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/update-contact`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ContactAssignEntityApiV1ContactAssignEntityPost
   * @summary Contact Assign Entity
   * @request POST:/contact-assign-entity
   * @secure
   */
  contactAssignEntityApiV1ContactAssignEntityPost = (
    query: {
      /** Contact Id */
      contact_id: string;
      /** Contact Types */
      contact_types: string;
      /** New Entity Name */
      new_entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/contact-assign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ContactUnassignEntityApiV1ContactUnassignEntityPost
   * @summary Contact Unassign Entity
   * @request POST:/contact-unassign-entity
   * @secure
   */
  contactUnassignEntityApiV1ContactUnassignEntityPost = (
    query: {
      /** Contact Id */
      contact_id: string;
      /** Entity Name */
      entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/contact-unassign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetContactAssignedEntitiesApiV1GetContactAssignedEntitiesGet
   * @summary Get Contact Assigned Entities
   * @request GET:/get-contact-assigned-entities
   * @secure
   */
  getContactAssignedEntitiesApiV1GetContactAssignedEntitiesGet = (
    query: {
      /** Contact Id */
      contact_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Entity[], HTTPValidationError>({
      path: `/get-contact-assigned-entities`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name CreateIamUserApiV1CreateIamUserPost
   * @summary Create Iam User
   * @request POST:/create-iam-user
   * @secure
   */
  createIamUserApiV1CreateIamUserPost = (data: IamUserCreate, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/create-iam-user`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name ListIamUserApiV1ListIamUserGet
   * @summary List Iam User
   * @request GET:/list-iam-user
   * @secure
   */
  listIamUserApiV1ListIamUserGet = (
    query?: {
      /** Username */
      username?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<IamUser[], HTTPValidationError>({
      path: `/list-iam-user`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name RemoveIamUserApiV1RemoveIamUserPost
   * @summary Remove Iam User
   * @request POST:/remove-iam-user
   * @secure
   */
  removeIamUserApiV1RemoveIamUserPost = (
    query: {
      /** Iam User Id */
      iam_user_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-iam-user`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly, logging
   * @name UpdateIamUserApiV1UpdateIamUserPost
   * @summary Update Iam User
   * @request POST:/update-iam-user
   * @secure
   */
  updateIamUserApiV1UpdateIamUserPost = (data: IamUserUpdate, params: RequestParams = {}) =>
    this.request<IamUser, HTTPValidationError>({
      path: `/update-iam-user`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly, logging
   * @name IamUserEnableMfaApiV1IamUserEnableMfaPost
   * @summary Iam User Enable Mfa
   * @request POST:/iam-user-enable-mfa
   * @secure
   */
  iamUserEnableMfaApiV1IamUserEnableMfaPost = (
    query?: {
      /** An enumeration. */
      type?: MfaType;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/iam-user-enable-mfa`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly, logging
   * @name IamUserDisableMfaApiV1IamUserDisableMfaPost
   * @summary Iam User Disable Mfa
   * @request POST:/iam-user-disable-mfa
   * @secure
   */
  iamUserDisableMfaApiV1IamUserDisableMfaPost = (params: RequestParams = {}) =>
    this.request<object, any>({
      path: `/iam-user-disable-mfa`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name IamUserUpdateRoleApiV1IamUserUpdateRolePost
   * @summary Iam User Update Role
   * @request POST:/iam-user-update-role
   * @secure
   */
  iamUserUpdateRoleApiV1IamUserUpdateRolePost = (
    query: {
      /** An enumeration. */
      new_role: IamRole;
      /** Iam User Id */
      iam_user_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/iam-user-update-role`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name NewIamUserSetupTemplateApiV1NewIamUserSetupTemplateGet
   * @summary New Iam User Setup Template
   * @request GET:/new-iam-user-setup-template
   */
  newIamUserSetupTemplateApiV1NewIamUserSetupTemplateGet = (
    query: {
      /** Iam User Token */
      iam_user_token: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/new-iam-user-setup-template`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly, logging
   * @name NewIamUserSetupPasswordApiV1NewIamUserSetPasswordPost
   * @summary New Iam User Setup Password
   * @request POST:/new-iam-user-set-password
   */
  newIamUserSetupPasswordApiV1NewIamUserSetPasswordPost = (
    data: BodyNewIamUserSetupPasswordApiV1NewIamUserSetPasswordPost,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/new-iam-user-set-password`,
      method: 'POST',
      body: data,
      type: ContentType.UrlEncoded,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name IamUserAssignEntityApiV1IamUserAssignEntityPost
   * @summary Iam User Assign Entity
   * @request POST:/iam-user-assign-entity
   * @secure
   */
  iamUserAssignEntityApiV1IamUserAssignEntityPost = (
    query: {
      /** Iam User Id */
      iam_user_id: string;
      /** New Entity Name */
      new_entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/iam-user-assign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name CreateEpNodeGroupApiV1CreateEndpointNodeGroupPost
   * @summary Create Ep Node Group
   * @request POST:/create-endpoint-node-group
   * @secure
   */
  createEpNodeGroupApiV1CreateEndpointNodeGroupPost = (
    data: EpNodeGroupCreate,
    params: RequestParams = {},
  ) =>
    this.request<EpNodeGroup, HTTPValidationError>({
      path: `/create-endpoint-node-group`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name ListEpNodeGroupApiV1ListEndpointNodeGroupGet
   * @summary List Ep Node Group
   * @request GET:/list-endpoint-node-group
   * @secure
   */
  listEpNodeGroupApiV1ListEndpointNodeGroupGet = (
    query?: {
      /** Ep Node Group Name */
      ep_node_group_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpNodeGroup[], HTTPValidationError>({
      path: `/list-endpoint-node-group`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name GetEpNodeGroupDetailsApiV1GetEndpointNodeGroupDetailsGet
   * @summary Get Ep Node Group Details
   * @request GET:/get-endpoint-node-group-details
   * @secure
   */
  getEpNodeGroupDetailsApiV1GetEndpointNodeGroupDetailsGet = (
    query: {
      /** Ep Node Group Id */
      ep_node_group_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpNodeGroupDetail, HTTPValidationError>({
      path: `/get-endpoint-node-group-details`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name RemoveEpNodeGroupApiV1RemoveEndpointNodeGroupPost
   * @summary Remove Ep Node Group
   * @request POST:/remove-endpoint-node-group
   * @secure
   */
  removeEpNodeGroupApiV1RemoveEndpointNodeGroupPost = (
    query: {
      /** Ep Node Group Id */
      ep_node_group_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-endpoint-node-group`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name CreateEpNodeApiV1CreateEndpointNodePost
   * @summary Create Ep Node
   * @request POST:/create-endpoint-node
   * @secure
   */
  createEpNodeApiV1CreateEndpointNodePost = (data: EpNodeCreate, params: RequestParams = {}) =>
    this.request<EpNode, HTTPValidationError>({
      path: `/create-endpoint-node`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name ListEpNodeApiV1ListEndpointNodeGet
   * @summary List Ep Node
   * @request GET:/list-endpoint-node
   * @secure
   */
  listEpNodeApiV1ListEndpointNodeGet = (
    query?: {
      /** Ep Node Group Id */
      ep_node_group_id?: string;
      /** Ep Node Name */
      ep_node_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpNode[], HTTPValidationError>({
      path: `/list-endpoint-node`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name RemoveEpNodeApiV1RemoveEndpointNodePost
   * @summary Remove Ep Node
   * @request POST:/remove-endpoint-node
   * @secure
   */
  removeEpNodeApiV1RemoveEndpointNodePost = (
    query: {
      /** Ep Node Group Id */
      ep_node_group_id: string;
      /** Ep Node Id */
      ep_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-endpoint-node`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, readonly
   * @name GetEndpointNodeDetailApiV1GetEndpointNodeDetailGet
   * @summary Get Endpoint Node Detail
   * @request GET:/get-endpoint-node-detail
   * @secure
   */
  getEndpointNodeDetailApiV1GetEndpointNodeDetailGet = (
    query: {
      /** Ep Node Id */
      ep_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<EpNodeDetail, HTTPValidationError>({
      path: `/get-endpoint-node-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin
   * @name PrepareEpnOvaApiV1PrepareEpnOvaGet
   * @summary Prepare Epn Ova
   * @request GET:/prepare-epn-ova
   * @secure
   */
  prepareEpnOvaApiV1PrepareEpnOvaGet = (
    query: {
      /** Ep Node Id */
      ep_node_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/prepare-epn-ova`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name AddEndpointNodeSecondaryIpsApiV1AddEndpointNodeSecondaryIpsPost
   * @summary Add Endpoint Node Secondary Ips
   * @request POST:/add-endpoint-node-secondary-ips
   * @secure
   */
  addEndpointNodeSecondaryIpsApiV1AddEndpointNodeSecondaryIpsPost = (
    query: {
      /** Ep Node Id */
      ep_node_id: string;
      /** Secondary Ips */
      secondary_ips: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/add-endpoint-node-secondary-ips`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name SetEndpointNodeFormFactorApiV1SetEndpointNodeFormFactorPost
   * @summary Set Endpoint Node Form Factor
   * @request POST:/set-endpoint-node-form-factor
   * @secure
   */
  setEndpointNodeFormFactorApiV1SetEndpointNodeFormFactorPost = (
    data: SetNodeFormFactor,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-endpoint-node-form-factor`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name ConfigureLanInterfaceApiV1ConfigureLanInterfacePost
   * @summary Configure Lan Interface
   * @request POST:/configure-lan-interface
   * @secure
   */
  configureLanInterfaceApiV1ConfigureLanInterfacePost = (
    data: LANInterface,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-lan-interface`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name ConfigureDhcpRelayApiV1ConfigureDhcpRelayPost
   * @summary Configure Dhcp Relay
   * @request POST:/configure-dhcp-relay
   * @secure
   */
  configureDhcpRelayApiV1ConfigureDhcpRelayPost = (data: DHCPRelay, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-dhcp-relay`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags consumer, admin, logging
   * @name ConfigureVrrpApiV1ConfigureVrrpPost
   * @summary Configure Vrrp
   * @request POST:/configure-vrrp
   * @secure
   */
  configureVrrpApiV1ConfigureVrrpPost = (data: VRRPConfig, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-vrrp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name CpeProductsApiV1CpeProductsGet
   * @summary Cpe Products
   * @request GET:/cpe-products
   */
  cpeProductsApiV1CpeProductsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/cpe-products`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetPeerIpApiV1GetPeerIpGet
   * @summary Get Peer Ip
   * @request GET:/get-peer-ip
   */
  getPeerIpApiV1GetPeerIpGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/get-peer-ip`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * @description Load regions from S3 bucket or local file and get all region keys. First tries to download from S3 and save to local file. If that fails, falls back to using the local file if it exists. Returns regions in alphabetical order with location names for display purposes.
   *
   * @tags common, readonly
   * @name GetPeerRegionsApiV1GetPeerRegionsGet
   * @summary Get Peer Regions
   * @request GET:/get-peer-regions
   */
  getPeerRegionsApiV1GetPeerRegionsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/get-peer-regions`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * @description Create a CPE with given parameters.
   *
   * @tags common, admin, logging
   * @name CreateCpeApiV1CreateCpePost
   * @summary Create Cpe
   * @request POST:/create-cpe
   * @secure
   */
  createCpeApiV1CreateCpePost = (data: CpeCreate, params: RequestParams = {}) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/create-cpe`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetCpeApiV1GetCpeGet
   * @summary Get Cpe
   * @request GET:/get-cpe
   * @secure
   */
  getCpeApiV1GetCpeGet = (
    query?: {
      /** Cpe Name */
      cpe_name?: string;
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe[], HTTPValidationError>({
      path: `/get-cpe`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetCpeDetailApiV1GetCpeDetailGet
   * @summary Get Cpe Detail
   * @request GET:/get-cpe-detail
   * @secure
   */
  getCpeDetailApiV1GetCpeDetailGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CpeDetail, HTTPValidationError>({
      path: `/get-cpe-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name RemoveCpeApiV1RemoveCpePost
   * @summary Remove Cpe
   * @request POST:/remove-cpe
   * @secure
   */
  removeCpeApiV1RemoveCpePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-cpe`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name UpdateCpeInfoApiV1UpdateCpeInfoPost
   * @summary Update Cpe Info
   * @request POST:/update-cpe-info
   * @secure
   */
  updateCpeInfoApiV1UpdateCpeInfoPost = (data: CpeInfoUpdate, params: RequestParams = {}) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/update-cpe-info`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleCpeNetflowApiV1ToggleCpeNetflowPost
   * @summary Toggle Cpe Netflow
   * @request POST:/toggle-cpe-netflow
   * @secure
   */
  toggleCpeNetflowApiV1ToggleCpeNetflowPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-netflow`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleCpeMonitorInboundPubIpApiV1ToggleCpeMonitorInboundPubIpPost
   * @summary Toggle Cpe Monitor Inbound Pub Ip
   * @request POST:/toggle-cpe-monitor-inbound-pub-ip
   * @secure
   */
  toggleCpeMonitorInboundPubIpApiV1ToggleCpeMonitorInboundPubIpPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-monitor-inbound-pub-ip`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleCpeMonitorOutboundPubIpApiV1ToggleCpeMonitorOutboundPubIpPost
   * @summary Toggle Cpe Monitor Outbound Pub Ip
   * @request POST:/toggle-cpe-monitor-outbound-pub-ip
   * @secure
   */
  toggleCpeMonitorOutboundPubIpApiV1ToggleCpeMonitorOutboundPubIpPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-monitor-outbound-pub-ip`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleCpeGeoVisibilityApiV1ToggleCpeGeoVisibilityPost
   * @summary Toggle Cpe Geo Visibility
   * @request POST:/toggle-cpe-geo-visibility
   * @secure
   */
  toggleCpeGeoVisibilityApiV1ToggleCpeGeoVisibilityPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-geo-visibility`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleCpeDosApiV1ToggleCpeDenialOfServicePost
   * @summary Toggle Cpe Dos
   * @request POST:/toggle-cpe-denial-of-service
   * @secure
   */
  toggleCpeDosApiV1ToggleCpeDenialOfServicePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-denial-of-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name SetCpeDenialOfServiceThresholdsApiV1SetCpeDenialOfServiceThresholdsPost
   * @summary Set Cpe Denial Of Service Thresholds
   * @request POST:/set-cpe-denial-of-service-thresholds
   * @secure
   */
  setCpeDenialOfServiceThresholdsApiV1SetCpeDenialOfServiceThresholdsPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    data: BodySetCpeDenialOfServiceThresholdsApiV1SetCpeDenialOfServiceThresholdsPost,
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/set-cpe-denial-of-service-thresholds`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Get denial of service thresholds for a specific CPE
   *
   * @tags common, admin, logging
   * @name GetCpeDenialOfServiceThresholdsApiV1GetCpeDenialOfServiceThresholdsGet
   * @summary Get Cpe Denial Of Service Thresholds
   * @request GET:/get-cpe-denial-of-service-thresholds
   * @secure
   */
  getCpeDenialOfServiceThresholdsApiV1GetCpeDenialOfServiceThresholdsGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/get-cpe-denial-of-service-thresholds`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleCpeDosAlertApiV1ToggleCpeDenialOfServiceAlertPost
   * @summary Toggle Cpe Dos Alert
   * @request POST:/toggle-cpe-denial-of-service-alert
   * @secure
   */
  toggleCpeDosAlertApiV1ToggleCpeDenialOfServiceAlertPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-denial-of-service-alert`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleCpeMaliciousIpBlockApiV1ToggleCpeMaliciousIpBlockPost
   * @summary Toggle Cpe Malicious Ip Block
   * @request POST:/toggle-cpe-malicious-ip-block
   * @secure
   */
  toggleCpeMaliciousIpBlockApiV1ToggleCpeMaliciousIpBlockPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/toggle-cpe-malicious-ip-block`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name StartCpeTestApiV1StartCpeTestPost
   * @summary Start Cpe Test
   * @request POST:/start-cpe-test
   * @secure
   */
  startCpeTestApiV1StartCpeTestPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Peer Ip */
      peer_ip: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/start-cpe-test`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Start RFC2544 performance test with an iperf server
   *
   * @tags common, readonly
   * @name StartCpePerformanceTestApiV1StartCpePerformanceTestPost
   * @summary Start Cpe Performance Test
   * @request POST:/start-cpe-performance-test
   * @secure
   */
  startCpePerformanceTestApiV1StartCpePerformanceTestPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Region */
      region: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/start-cpe-performance-test`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetCpeTestReportApiV1GetCpeTestReportGet
   * @summary Get Cpe Test Report
   * @request GET:/get-cpe-test-report
   * @secure
   */
  getCpeTestReportApiV1GetCpeTestReportGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/get-cpe-test-report`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name CpeAssignEntityApiV1CpeAssignEntityPost
   * @summary Cpe Assign Entity
   * @request POST:/cpe-assign-entity
   * @secure
   */
  cpeAssignEntityApiV1CpeAssignEntityPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** New Entity Name */
      new_entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/cpe-assign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name StartCpeIpServiceApiV1StartCpeIpServicePost
   * @summary Start Cpe Ip Service
   * @request POST:/start-cpe-ip-service
   * @secure
   */
  startCpeIpServiceApiV1StartCpeIpServicePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/start-cpe-ip-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name StopCpeIpServiceApiV1StopCpeIpServicePost
   * @summary Stop Cpe Ip Service
   * @request POST:/stop-cpe-ip-service
   * @secure
   */
  stopCpeIpServiceApiV1StopCpeIpServicePost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/stop-cpe-ip-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name UpdateCpeIpMonitorTargetApiV1UpdateCpeIpMonitorTargetPost
   * @summary Update Cpe Ip Monitor Target
   * @request POST:/update_cpe_ip_monitor_target
   * @secure
   */
  updateCpeIpMonitorTargetApiV1UpdateCpeIpMonitorTargetPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Ip Monitor Target */
      ip_monitor_target?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/update_cpe_ip_monitor_target`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Update CPE Mode.
   *
   * @tags common, admin, logging
   * @name EditCpeNetworkApiV1EditCpeNetworkPost
   * @summary Edit Cpe Network
   * @request POST:/edit-cpe-network
   * @secure
   */
  editCpeNetworkApiV1EditCpeNetworkPost = (data: CpeEditNetwork, params: RequestParams = {}) =>
    this.request<Cpe, HTTPValidationError>({
      path: `/edit-cpe-network`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name SetCpeScanIntervalApiV1SetCpeScanIntervalPost
   * @summary Set Cpe Scan Interval
   * @request POST:/set-cpe-scan-interval
   * @secure
   */
  setCpeScanIntervalApiV1SetCpeScanIntervalPost = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Scan Interval */
      scan_interval: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/set-cpe-scan-interval`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin
   * @name GetCpeScanIntervalApiV1GetCpeScanIntervalGet
   * @summary Get Cpe Scan Interval
   * @request GET:/get-cpe-scan-interval
   * @secure
   */
  getCpeScanIntervalApiV1GetCpeScanIntervalGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/get-cpe-scan-interval`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ConfigureIperfServerApiV1ConfigureIperfServerPost
   * @summary Configure Iperf Server
   * @request POST:/configure-iperf-server
   * @secure
   */
  configureIperfServerApiV1ConfigureIperfServerPost = (
    data: IperfServer,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-iperf-server`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name ConfigurePerfTestScheduleApiV1ConfigurePerfTestSchedulePost
   * @summary Configure Perf Test Schedule
   * @request POST:/configure-perf-test-schedule
   * @secure
   */
  configurePerfTestScheduleApiV1ConfigurePerfTestSchedulePost = (
    data: PerfTestSchedule,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/configure-perf-test-schedule`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common
   * @name GetLanInterfacesApiV1GetCpeLanInterfacesGet
   * @summary Get Lan Interfaces
   * @request GET:/get-cpe-lan-interfaces
   * @secure
   */
  getLanInterfacesApiV1GetCpeLanInterfacesGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string[], HTTPValidationError>({
      path: `/get-cpe-lan-interfaces`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Create a Entity with given parameters.
   *
   * @tags common, admin, logging
   * @name CreateEntityApiV1CreateEntityPost
   * @summary Create Entity
   * @request POST:/create-entity
   * @secure
   */
  createEntityApiV1CreateEntityPost = (data: EntityCreate, params: RequestParams = {}) =>
    this.request<Entity, HTTPValidationError>({
      path: `/create-entity`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description If logged in as account owner: - If entity_name is specified, we return the specific entity - If entity_name is None, we return all entities belong to this account If logged in as IAM user: - If IAM user does not belong to an entity, we treat it as account owner - If IAM user belong to an entity, - If entity_name is specified, - If this IAM user's entity has the same name as entity_name, we return entity, otherwise, we return empty list - If entity_name is not specified, we return this entity plus all its child entities
   *
   * @tags common, readonly
   * @name GetEntityApiV1GetEntityGet
   * @summary Get Entity
   * @request GET:/get-entity
   * @secure
   */
  getEntityApiV1GetEntityGet = (
    query?: {
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Entity[], HTTPValidationError>({
      path: `/get-entity`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetEntityNamesApiV1GetEntityNamesGet
   * @summary Get Entity Names
   * @request GET:/get-entity-names
   * @secure
   */
  getEntityNamesApiV1GetEntityNamesGet = (
    query?: {
      /** Parent */
      parent?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<string[], HTTPValidationError>({
      path: `/get-entity-names`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name RemoveEntityApiV1RemoveEntityPost
   * @summary Remove Entity
   * @request POST:/remove-entity
   * @secure
   */
  removeEntityApiV1RemoveEntityPost = (
    query: {
      /** Entity Id */
      entity_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetEntityIamUsersApiV1GetEntityIamUsersGet
   * @summary Get Entity Iam Users
   * @request GET:/get-entity-iam-users
   * @secure
   */
  getEntityIamUsersApiV1GetEntityIamUsersGet = (
    query: {
      /** Entity Id */
      entity_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<IamUser[], HTTPValidationError>({
      path: `/get-entity-iam-users`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name AssignEntityParentApiV1AssignEntityParentPost
   * @summary Assign Entity Parent
   * @request POST:/assign-entity-parent
   * @secure
   */
  assignEntityParentApiV1AssignEntityParentPost = (
    query: {
      /** Entity Id */
      entity_id: string;
      /** Parent Entity Name */
      parent_entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/assign-entity-parent`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name EditEntityDescriptionApiV1EditEntityDescriptionPost
   * @summary Edit Entity Description
   * @request POST:/edit-entity-description
   * @secure
   */
  editEntityDescriptionApiV1EditEntityDescriptionPost = (
    query: {
      /** Entity Id */
      entity_id: string;
      /** Description */
      description: string;
      /** Email */
      email?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-entity-description`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetApiLogApiV1GetApiLogGet
   * @summary Get Api Log
   * @request GET:/get-api-log
   * @secure
   */
  getApiLogApiV1GetApiLogGet = (params: RequestParams = {}) =>
    this.request<ApiLog[], any>({
      path: `/get-api-log`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name MetroProductsApiV1MetroProductsGet
   * @summary Metro Products
   * @request GET:/metro-products
   */
  metroProductsApiV1MetroProductsGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/metro-products`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name MetroCcmIntervalApiV1MetroCcmIntervalGet
   * @summary Metro Ccm Interval
   * @request GET:/metro-ccm-interval
   */
  metroCcmIntervalApiV1MetroCcmIntervalGet = (params: RequestParams = {}) =>
    this.request<number[], any>({
      path: `/metro-ccm-interval`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * @description Create a Metro device with given parameters.
   *
   * @tags common, admin, logging
   * @name CreateMetroApiV1CreateMetroPost
   * @summary Create Metro
   * @request POST:/create-metro
   * @secure
   */
  createMetroApiV1CreateMetroPost = (data: MetroCreate, params: RequestParams = {}) =>
    this.request<Metro, HTTPValidationError>({
      path: `/create-metro`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetMetroApiV1GetMetroGet
   * @summary Get Metro
   * @request GET:/get-metro
   * @secure
   */
  getMetroApiV1GetMetroGet = (
    query?: {
      /** Metro Name */
      metro_name?: string;
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro[], HTTPValidationError>({
      path: `/get-metro`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetMetroDetailApiV1GetMetroDetailGet
   * @summary Get Metro Detail
   * @request GET:/get-metro-detail
   * @secure
   */
  getMetroDetailApiV1GetMetroDetailGet = (
    query: {
      /** Metro Id */
      metro_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<MetroDetail, HTTPValidationError>({
      path: `/get-metro-detail`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name RemoveMetroApiV1RemoveMetroPost
   * @summary Remove Metro
   * @request POST:/remove-metro
   * @secure
   */
  removeMetroApiV1RemoveMetroPost = (
    query: {
      /** Metro Id */
      metro_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/remove-metro`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name UpdateMetroInfoApiV1UpdateMetroInfoPost
   * @summary Update Metro Info
   * @request POST:/update-metro-info
   * @secure
   */
  updateMetroInfoApiV1UpdateMetroInfoPost = (data: MetroInfoUpdate, params: RequestParams = {}) =>
    this.request<Metro, HTTPValidationError>({
      path: `/update-metro-info`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleMetroNetflowApiV1ToggleMetroNetflowPost
   * @summary Toggle Metro Netflow
   * @request POST:/toggle-metro-netflow
   * @secure
   */
  toggleMetroNetflowApiV1ToggleMetroNetflowPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-netflow`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleMetroMonitorInboundPubIpApiV1ToggleMetroMonitorInboundPubIpPost
   * @summary Toggle Metro Monitor Inbound Pub Ip
   * @request POST:/toggle-metro-monitor-inbound-pub-ip
   * @secure
   */
  toggleMetroMonitorInboundPubIpApiV1ToggleMetroMonitorInboundPubIpPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-monitor-inbound-pub-ip`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleMetroMonitorOutboundPubIpApiV1ToggleMetroMonitorOutboundPubIpPost
   * @summary Toggle Metro Monitor Outbound Pub Ip
   * @request POST:/toggle-metro-monitor-outbound-pub-ip
   * @secure
   */
  toggleMetroMonitorOutboundPubIpApiV1ToggleMetroMonitorOutboundPubIpPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-monitor-outbound-pub-ip`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleMetroGeoVisibilityApiV1ToggleMetroGeoVisibilityPost
   * @summary Toggle Metro Geo Visibility
   * @request POST:/toggle-metro-geo-visibility
   * @secure
   */
  toggleMetroGeoVisibilityApiV1ToggleMetroGeoVisibilityPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-geo-visibility`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleMetroDosApiV1ToggleMetroDenialOfServicePost
   * @summary Toggle Metro Dos
   * @request POST:/toggle-metro-denial-of-service
   * @secure
   */
  toggleMetroDosApiV1ToggleMetroDenialOfServicePost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-denial-of-service`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleMetroDosAlertApiV1ToggleMetroDenialOfServiceAlertPost
   * @summary Toggle Metro Dos Alert
   * @request POST:/toggle-metro-denial-of-service-alert
   * @secure
   */
  toggleMetroDosAlertApiV1ToggleMetroDenialOfServiceAlertPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-denial-of-service-alert`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name ToggleMetroMaliciousIpBlockApiV1ToggleMetroMaliciousIpBlockPost
   * @summary Toggle Metro Malicious Ip Block
   * @request POST:/toggle-metro-malicious-ip-block
   * @secure
   */
  toggleMetroMaliciousIpBlockApiV1ToggleMetroMaliciousIpBlockPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Enabled */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<Metro, HTTPValidationError>({
      path: `/toggle-metro-malicious-ip-block`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name MetroAssignEntityApiV1MetroAssignEntityPost
   * @summary Metro Assign Entity
   * @request POST:/metro-assign-entity
   * @secure
   */
  metroAssignEntityApiV1MetroAssignEntityPost = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** New Entity Name */
      new_entity_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/metro-assign-entity`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name EditOamApiV1EditOamPost
   * @summary Edit Oam
   * @request POST:/edit-oam
   * @secure
   */
  editOamApiV1EditOamPost = (data: MetroOamEdit, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/edit-oam`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, admin, logging
   * @name LoopbackTestApiV1LoopbackTestPost
   * @summary Loopback Test
   * @request POST:/loopback-test
   * @secure
   */
  loopbackTestApiV1LoopbackTestPost = (data: MetroLoopbackTest, params: RequestParams = {}) =>
    this.request<object, HTTPValidationError>({
      path: `/loopback-test`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name StartMetroTestApiV1StartMetroTestPost
   * @summary Start Metro Test
   * @request POST:/start-metro-test
   * @secure
   */
  startMetroTestApiV1StartMetroTestPost = (
    data: MetroPerformanceTest,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/start-metro-test`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name GetMetroTestReportApiV1GetMetroTestReportGet
   * @summary Get Metro Test Report
   * @request GET:/get-metro-test-report
   * @secure
   */
  getMetroTestReportApiV1GetMetroTestReportGet = (
    query: {
      /** Metro Id */
      metro_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/get-metro-test-report`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common
   * @name GetLanInterfacesApiV1GetMetroLanInterfacesGet
   * @summary Get Lan Interfaces
   * @request GET:/get-metro-lan-interfaces
   * @secure
   */
  getLanInterfacesApiV1GetMetroLanInterfacesGet = (
    query: {
      /** Metro Id */
      metro_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string[], HTTPValidationError>({
      path: `/get-metro-lan-interfaces`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name AnalyzePcapApiV1AnalyzePcapPost
   * @summary Analyze Pcap
   * @request POST:/analyze-pcap
   * @secure
   */
  analyzePcapApiV1AnalyzePcapPost = (
    data: BodyAnalyzePcapApiV1AnalyzePcapPost,
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/analyze-pcap`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });
  /**
   * @description Analyze a PCAP file stored in an S3 bucket. :param account_user: Authenticated user details (Account, IAM User). :param pcap_file_key: Key of the PCAP file in S3. :param pcap_file_name: Name of the PCAP file being analyzed. :return: JSON response containing session analysis results. This function first validates the user's access and file extension. If valid, it attempts to decode the PCAP file and generate a report.
   *
   * @tags common, admin
   * @name AnalyzeS3PcapApiV1AnalyzeS3PcapGet
   * @summary Analyze S3 Pcap
   * @request GET:/analyze-s3-pcap
   * @secure
   */
  analyzeS3PcapApiV1AnalyzeS3PcapGet = (
    query: {
      /** Pcap File Key */
      pcap_file_key: string;
      /** Pcap File Name */
      pcap_file_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/analyze-s3-pcap`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Generate a pre-signed URL for uploading a PCAP file to S3. :param account_user: Authenticated user details (Account, IAM User). :param pcap_file_name: Name of the PCAP file to be uploaded. :return: JSON response containing the pre-signed upload URL and file key. This function first validates the user's access and file extension. If valid, it generates a pre-signed S3 upload URL and returns it to the client.
   *
   * @tags common, admin
   * @name GetS3UploadUrlApiV1GetS3UploadUrlGet
   * @summary Get S3 Upload Url
   * @request GET:/get-s3-upload-url
   * @secure
   */
  getS3UploadUrlApiV1GetS3UploadUrlGet = (
    query: {
      /** Pcap File Name */
      pcap_file_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<S3UploadUrl, HTTPValidationError>({
      path: `/get-s3-upload-url`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetSummaryApiV1DashboardGetSummaryGet
   * @summary Dashboard Get Summary
   * @request GET:/dashboard-get-summary
   * @secure
   */
  dashboardGetSummaryApiV1DashboardGetSummaryGet = (
    query?: {
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-summary`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetDeviceNamesApiV1DashboardGetDeviceNamesGet
   * @summary Dashboard Get Device Names
   * @request GET:/dashboard-get-device-names
   * @secure
   */
  dashboardGetDeviceNamesApiV1DashboardGetDeviceNamesGet = (
    query?: {
      /** Entity Name */
      entity_name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-device-names`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetNodePeakAvgUtilIndividualApiV1DashboardGetNodePeakAvgUtilIndividualGet
   * @summary Dashboard Get Node Peak Avg Util Individual
   * @request GET:/dashboard-get-node-peak-avg-util-individual
   * @secure
   */
  dashboardGetNodePeakAvgUtilIndividualApiV1DashboardGetNodePeakAvgUtilIndividualGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/dashboard-get-node-peak-avg-util-individual`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetNodeWanLinkHealthApiV1DashboardGetNodeWanLinkHealthGet
   * @summary Dashboard Get Node Wan Link Health
   * @request GET:/dashboard-get-node-wan-link-health
   * @secure
   */
  dashboardGetNodeWanLinkHealthApiV1DashboardGetNodeWanLinkHealthGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any[], HTTPValidationError>({
      path: `/dashboard-get-node-wan-link-health`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetNodeAppHighlightApiV1DashboardGetNodeAppHighlightGet
   * @summary Dashboard Get Node App Highlight
   * @request GET:/dashboard-get-node-app-highlight
   * @secure
   */
  dashboardGetNodeAppHighlightApiV1DashboardGetNodeAppHighlightGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-node-app-highlight`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetNodeWanUtilizationHistogramApiV1DashboardGetNodeWanUtilizationHistogramGet
   * @summary Dashboard Get Node Wan Utilization Histogram
   * @request GET:/dashboard-get-node-wan-utilization-histogram
   * @secure
   */
  dashboardGetNodeWanUtilizationHistogramApiV1DashboardGetNodeWanUtilizationHistogramGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-node-wan-utilization-histogram`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetNodeSessionsApiV1DashboardGetNodeSessionsGet
   * @summary Dashboard Get Node Sessions
   * @request GET:/dashboard-get-node-sessions
   * @secure
   */
  dashboardGetNodeSessionsApiV1DashboardGetNodeSessionsGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-node-sessions`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetRouteApiV1DashboardGetRouteGet
   * @summary Dashboard Get Route
   * @request GET:/dashboard-get-route
   * @secure
   */
  dashboardGetRouteApiV1DashboardGetRouteGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-route`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetPeakHoursApiV1DashboardGetPeakHoursGet
   * @summary Dashboard Get Peak Hours
   * @request GET:/dashboard-get-peak-hours
   * @secure
   */
  dashboardGetPeakHoursApiV1DashboardGetPeakHoursGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-peak-hours`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetInboundSrcIpApiV1DashboardGetInboundSrcIpGet
   * @summary Dashboard Get Inbound Src Ip
   * @request GET:/dashboard-get-inbound-src-ip
   * @secure
   */
  dashboardGetInboundSrcIpApiV1DashboardGetInboundSrcIpGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-inbound-src-ip`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetOutboundDstIpApiV1DashboardGetOutboundDstIpGet
   * @summary Dashboard Get Outbound Dst Ip
   * @request GET:/dashboard-get-outbound-dst-ip
   * @secure
   */
  dashboardGetOutboundDstIpApiV1DashboardGetOutboundDstIpGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-outbound-dst-ip`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetLinkSpeedTestApiV1DashboardGetLinkSpeedTestGet
   * @summary Dashboard Get Link Speed Test
   * @request GET:/dashboard-get-link-speed-test
   * @secure
   */
  dashboardGetLinkSpeedTestApiV1DashboardGetLinkSpeedTestGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-link-speed-test`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetBlockedIpsApiV1DashboardGetBlockedIpsGet
   * @summary Dashboard Get Blocked Ips
   * @request GET:/dashboard-get-blocked-ips
   * @secure
   */
  dashboardGetBlockedIpsApiV1DashboardGetBlockedIpsGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-blocked-ips`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name DashboardGetBlockedIpsHistoryApiV1DashboardGetBlockedIpsHistoryGet
   * @summary Dashboard Get Blocked Ips History
   * @request GET:/dashboard-get-blocked-ips-history
   * @secure
   */
  dashboardGetBlockedIpsHistoryApiV1DashboardGetBlockedIpsHistoryGet = (
    query: {
      /** Node Id */
      node_id: string;
      /** Node Name */
      node_name: string;
      /** Start Time */
      start_time?: string;
      /** End Time */
      end_time?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<object, HTTPValidationError>({
      path: `/dashboard-get-blocked-ips-history`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name SseApiV1SseGet
   * @summary Sse
   * @request GET:/sse
   */
  sseApiV1SseGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/sse`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name CheckCpeTestStatusApiV1CheckCpeTestStatusGet
   * @summary Check Cpe Test Status
   * @request GET:/check_cpe_test_status
   */
  checkCpeTestStatusApiV1CheckCpeTestStatusGet = (
    query: {
      /** Cpe Id */
      cpe_id: string;
      /** Sse Id */
      sse_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/check_cpe_test_status`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags common, readonly
   * @name CheckMetroTestStatusApiV1CheckMetroTestStatusGet
   * @summary Check Metro Test Status
   * @request GET:/check_metro_test_status
   */
  checkMetroTestStatusApiV1CheckMetroTestStatusGet = (
    query: {
      /** Metro Id */
      metro_id: string;
      /** Sse Id */
      sse_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/check_metro_test_status`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
}
